import React, { createContext, useContext, useState } from 'react';

const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [openChats, setOpenChats] = useState([]);

  const openChat = (eventId, eventName, eventStatus) => {
    // Check if chat is already open
    const isAlreadyOpen = openChats.some(chat => chat.eventId === eventId);
    if (isAlreadyOpen) {
      return; // Don't open duplicate chats
    }

    // Add new chat to the list
    const newChat = {
      eventId,
      eventName,
      eventStatus,
      position: {
        bottom: 20 + (openChats.length * 70), // Stack chats vertically
        right: 20
      }
    };

    setOpenChats(prev => [...prev, newChat]);
  };

  const closeChat = (eventId) => {
    setOpenChats(prev => prev.filter(chat => chat.eventId !== eventId));
  };

  const closeAllChats = () => {
    setOpenChats([]);
  };

  const value = {
    openChats,
    openChat,
    closeChat,
    closeAllChats
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};
